import { Decodable } from "./_decodable";

/**
 * Interface para um campo de configuração de detalhes
 */
class DetailsConfigField extends Decodable {
    field: string;
    label: string;
    value: boolean;
}


export { 
    DetailsConfigField 
};